import { Component, OnInit } from '@angular/core';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '@services/roles/role.service';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-role-detail',
    templateUrl: './role-detail.component.html',
    styleUrls: ['./role-detail.component.scss'],
    providers: [RoleService],
    standalone: false
})
export class RoleDetailComponent implements OnInit {

  pageActions: PageAction[] = [];
  boundRole: Models.Role;
  id = null;

  constructor(private route: ActivatedRoute, private router: Router, private roleService: RoleService) {

  }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    if (this.id) {
      this.roleService.get(this.id).then(result => {
        this.boundRole = result;
      });
    }

    this.pageActions.push(new PageAction({
      icon: 'edit',
      title: 'Edit Role',
      callback: () => {
        this.router.navigate(['roles', this.id, 'edit']);
      }
    }));
  }

}
